import React, { Component, useEffect, lazy, Suspense } from 'react';
import Default from "../../../Layout/Default";
import { Routes, Route, Switch, useHistory } from "react-router-dom";
import AppLandingPage from '../Pages/AppLandingPage';
import LoginPage from '../Pages/LoginPage';
import ForgotPassword from '../Pages/ForgotPassword';
import AnotherLoginUrl from '../Pages/AnotherLoginUrl';
import logger from '../../../logger';
import * as Store from '../../../store'
import LoadingOverlay from 'react-loading-overlay';
import HomePage from '../../../HomePage';
import SettingsPage from '../../../SettingPage';
import Dashboard from '../../../V4/Modules/Dashboard/Pages/Dashboard';

function LoginRoute() {
    const history = useHistory();

    return (
        <Switch>
            {/* app landing page route */}
            <Route
                exact
                path="/"
                render={() => (
                    <Default history={history}>
                        <AppLandingPage history={history} />
                    </Default>
                )}
            />

            {/* login route */}
            <Route
                exact
                path="/:lng/login"
                render={() => (
                    <Default history={history}>
                        <LoginPage history={history} />
                    </Default>
                )}
            />

            {/* auto login route - cross-panel SSO */}
            <Route
                exact
                path="/:lng/auto_login"
                render={() => (
                    <AnotherLoginUrl history={history} />
                )}
            />

            {/* forget password route */}
            <Route
                exact
                path="/:lng/forgot_password/:type?/"
                render={() => (
                    <Default history={history}>
                        <ForgotPassword history={history} />
                    </Default>
                )}
            />


            <Route
                exact
                path="/:lng/home/:type?/"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        {/* <p>Login Success</p> */}
                        <Dashboard history={history} />
                    </Suspense>
                )}
            />

            {/* setting module route */}
            <Route
                exact
                path="/:lng/settings/:type?/:next_step?"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <SettingsPage history={history} />
                    </Suspense>
                )}
            />

        </Switch>
    );

}

function Loading() {
    return (
        <>
            <div className="wrapperContainer">
                <LoadingOverlay
                    active={true}
                    className='lodingOverlayDivContainer'
                    styles={{
                        overlay: (base) => ({
                            ...base,
                            background: 'rgba(255, 255, 255, 0.1)',
                            zIndex: '9999999999999'
                        })
                    }}
                ></LoadingOverlay>
            </div>
        </>
    );
}


export default LoginRoute;
